module.exports = __webpack_public_path__ + "static/media/Rhitishah_Raju.b87d4976.png";